import { inboxConstants } from '@constants/inbox';
import { inboxService } from '@services';
import { applyMessageStatus } from '@helpers/inbox';

export const inboxActions = {
    getHistory,
    update,
    addMessage,
    updateMessageStatus,
    reset,
};

function getHistory(conversationId, withLoading = true) {
    return dispatch => {
        if (withLoading) {
            dispatch(request());
        }
        inboxService.getHistory(conversationId).then(
            data => dispatch(success(data, conversationId)),
            () => dispatch(failure()),
        );
    };
}

function request() {
    return { type: inboxConstants.INBOX_HISTORY_FETCH };
}

function success(data, conversationId) {
    return { type: inboxConstants.INBOX_HISTORY_SUCCESS, data, conversationId };
}

function failure() {
    return { type: inboxConstants.INBOX_HISTORY_ERROR };
}

function update(data) {
    return { type: inboxConstants.INBOX_HISTORY_UPDATE, data };
}

function addMessage(conversationId, message) {
    return { type: inboxConstants.INBOX_MESSAGE_ADD, conversationId, message };
}

function updateMessageStatus(payload) {
    return (dispatch, getState) => {
        const updated = applyMessageStatus(getState().inbox.data, payload);
        if (updated) {
            dispatch(update(updated));
        }
        return Boolean(updated);
    };
}

function reset() {
    return { type: inboxConstants.INBOX_RESET };
}
